/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import ConversationscreateGroupSmsConversation from './ConversationscreateGroupSmsConversation';

/**
 * The ConversationsCreateGroupSmsBody model module.
 * @module model/ConversationsCreateGroupSmsBody
 * @version v0.3
 */
export default class ConversationsCreateGroupSmsBody {
  /**
   * Constructs a new <code>ConversationsCreateGroupSmsBody</code>.
   * @alias module:model/ConversationsCreateGroupSmsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ConversationsCreateGroupSmsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ConversationsCreateGroupSmsBody} obj Optional instance to populate.
   * @return {module:model/ConversationsCreateGroupSmsBody} The populated <code>ConversationsCreateGroupSmsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ConversationsCreateGroupSmsBody();
      if (data.hasOwnProperty('conversation'))
        obj.conversation = ConversationscreateGroupSmsConversation.constructFromObject(data['conversation']);
    }
    return obj;
  }
}

/**
 * @member {module:model/ConversationscreateGroupSmsConversation} conversation
 */
ConversationsCreateGroupSmsBody.prototype.conversation = undefined;

